export enum StreetFurnitureType {
  Tree,
  StreetLight,
  Pole,
  ParkingMeter,
  RoadSign,
  BusStop,
  FootPath,
  Other,
}
